export const SNACKBAR_DURATION = 6000
